// The dashboard's colour palettes, offered in the top bar's Settings panel.
// Each id needs a matching block in src/styles/global/25a-layer-base-theme-palettes.css,
// which is where the colours themselves live.
export const THEME_PALETTE = {
  CLASSIC_BLUE: "classic-blue",
  SAUDI_GREEN: "saudi-green",
  RED_SEA_TEAL: "red-sea-teal",
  DIRIYAH_CLAY: "diriyah-clay",
  ROYAL_LAVENDER: "royal-lavender",
  NAJD_NIGHT: "najd-night",
  TAIF_POMEGRANATE: "taif-pomegranate",
  NAFUD_SAND: "nafud-sand",
  JOUF_OLIVE: "jouf-olive",
};

export const DEFAULT_THEME_PALETTE = THEME_PALETTE.CLASSIC_BLUE;

export const THEME_PALETTES = [
  {
    id: THEME_PALETTE.CLASSIC_BLUE,
    labelKey: "settings.palettes.classicBlue",
  },
  {
    id: THEME_PALETTE.SAUDI_GREEN,
    labelKey: "settings.palettes.saudiGreen",
  },
  {
    id: THEME_PALETTE.RED_SEA_TEAL,
    labelKey: "settings.palettes.redSeaTeal",
  },
  {
    id: THEME_PALETTE.DIRIYAH_CLAY,
    labelKey: "settings.palettes.diriyahClay",
  },
  {
    id: THEME_PALETTE.ROYAL_LAVENDER,
    labelKey: "settings.palettes.royalLavender",
  },
  {
    id: THEME_PALETTE.NAJD_NIGHT,
    labelKey: "settings.palettes.najdNight",
  },
  {
    id: THEME_PALETTE.TAIF_POMEGRANATE,
    labelKey: "settings.palettes.taifPomegranate",
  },
  {
    id: THEME_PALETTE.NAFUD_SAND,
    labelKey: "settings.palettes.nafudSand",
  },
  {
    id: THEME_PALETTE.JOUF_OLIVE,
    labelKey: "settings.palettes.joufOlive",
  },
];
